import type { IncludeFieldSet } from '@domain/types/entity';
import { getFeatureFlag } from '@root/helpers/feature-flags';

export const getResourcesListToFetch = (): IncludeFieldSet[] => {
  const hasAttachmentsFeature = getFeatureFlag('Attachments');

  const include: IncludeFieldSet[] = ['blocks', 'comments', 'contract_missing_data', 'endorsement_materiality'];

  if (hasAttachmentsFeature) {
    include.push('attachments');
  }

  return include;
};
